export default "__VITE_ASSET__QzujAWVE__"